import React, { useRef, useState } from 'react';
import axios from 'axios';
import "./BusinessFAQ.css";
import flashMessage from '../HelperFunctions';


function BusinessFAQ({ organization, onChange }) {
  const [isSaving, setIsSaving] = useState(false);  // State to handle "saving..." message
  const placeholderText = `Frequently asked questions about your business and their answers.`;

  const typingTimer = useRef(null);
  const faqInputRef = useRef(null);

  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  return (

    <div className="customize-ai-section">
      <span>Business FAQ</span>
      <textarea
        data-say-id="knowledge-base-faq"
        ref={faqInputRef}
        className="business-faq-text"
        placeholder={placeholderText}
        defaultValue={organization.business_faq}
        onChange={handleInputChange}
      />

    </div>

  );
}

export default BusinessFAQ
